import React from 'react';
import {
    FaArrowRight,
    FaFacebookMessenger,
    FaRegEnvelope,
    FaWhatsapp
} from 'react-icons/fa';
import "../../assets/style/Contact.css";
import {useTranslation} from "react-i18next"


const Card: React.FC = () => {
    const { t } = useTranslation('fr', { useSuspense: false });
    return (
        <div className="contact__content">
            <div className="contact__info">
                <div className="contact__card">
                    <FaRegEnvelope className="contact__card-icon" />
                    <h3 className="contact__card__title">E-mail</h3>
                    <span className="contact__card__data"
                    >ravakiniainatokyhary@gmail.com
                    </span>
                    <a
                        href="mailto:ravakiniainatokyhary@gmail.com"
                        target="_blank"
                        className="contact__button"
                        rel="noreferrer"
                    >
                        {t('writeToMe')}
                        <FaArrowRight className="contact__button-icon" />  </a>
                </div>

                <div className="contact__card">
                    <FaWhatsapp className="contact__card-icon" />
                    <h3 className="contact__card__title">Whatsapp</h3>
                    <span className="contact__card__data">+ 261 34 89 040 76</span>
                    <a
                        href="https://api.whatsapp.com/send?phone=+261348904076&text=Hello, more information!"
                        target="_blank"
                        className="contact__button"
                        rel="noreferrer"
                    >
                        {t('writeToMe')}
                        <FaArrowRight className="contact__button-icon" />
                    </a>
                </div>

                <div className="contact__card">
                    <FaFacebookMessenger className="contact__card-icon" />
                    <h3 className="contact__card__title">Messenger</h3>
                    <span className="contact__card__data">kavaraania.aina</span>
                    <a
                        href="https://m.me/kavaraania.aina/"
                        target="_blank"
                        className="contact__button"
                        rel="noreferrer"
                    >
                        {t('writeToMe')}
                        <FaArrowRight className="contact__button-icon" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Card;